import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NavigateFunction } from 'react-router-dom';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { DestinoPedidos, IDestinoPedidosPagingRes } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';

const { get, post, put } = erpApi();

///* tanSctack query

export const useFetchDestinoPedidos = ({
    page = 1,
    page_size = 10,
    nombre = '',
  }: GetDestinoPedidosParams) => {
    return useQuery({
      queryKey: ['destino-pedido', page, nombre, page_size], // Include ciudad in the query key
      queryFn: async () => {
        return getDestinoPedidos({ page, nombre, page_size }); // Pass ciudad to getDestinoPedidos
      },
    });
  };
  export const useGetDestinoPedido = (id: string) => {
    return useQuery({
      queryKey: ['destino-pedido', id],
      queryFn: async () => {
        return getDestinoPedido(id);
      },
    });
  };
  
  export const useCreateDestinoPedidos = (navigate: NavigateFunction, returnUrl: string,  enableNavigation = true) => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: createDestinoPedido,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['destino-pedido'] });
        enableNavigation && navigate(returnUrl, { replace: true });
      },
      onError: error => {
        handleAxiosError(error);
      },
    });
  };
  
  export const useUpdateDestinoPedidos = (navigate: NavigateFunction, returnUrl: string,
    noState?: boolean,
    enableNavigation?: boolean) => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: updateDestinoPedido,
      onSuccess: () => {
        noState && queryClient.invalidateQueries({ queryKey: ['destino-pedido'] });
        enableNavigation && navigate(returnUrl, { replace: true });
      },
      onError: error => {
        handleAxiosError(error);
      },
    });
  };
  
  ///* axios
  export type GetDestinoPedidosParams = {
    page?: number;
    page_size?: number;
    nombre?: string;
  };
  
  export type CreateDestinoPedidosParams = Omit<DestinoPedidos, 'id_destino_pedido'>;
  export type UpdateDestinoPedidosParams = {
    id: number;
    data: CreateDestinoPedidosParams;
  };
  
  export const getDestinoPedidos = async (params?: GetDestinoPedidosParams) => {
    const queryParams = getUrlParamsFetch({ ...params });
  
    return get<IDestinoPedidosPagingRes>(
      `${urlBackend}api/v1/destinos-pedido/?${queryParams}`,
      true
    );
  };
  
  export const getDestinoPedido = async (id: string) => {
    const setAlert = useUiStore.getState().setAlert;
    const res = await get<DestinoPedidos>(`${urlBackend}api/v1/destinos-pedido/${id}/`, true);
  
    res.status === 'error' && setAlert(true, res.message, res.status);
    return res;
  };
  
  export const createDestinoPedido = async (data: CreateDestinoPedidosParams) => {
    try{
      return await post<DestinoPedidos>(`${urlBackend}api/destinos-pedido/`, data, true);
    }
    catch(error){
      return handleAxiosError(error);
    }
  };
  
  export const updateDestinoPedido = async ({ id, data }: UpdateDestinoPedidosParams) => {
    const setAlert = useUiStore.getState().setAlert;
    const res = await put<DestinoPedidos>(`${urlBackend}api/v1/destinos-pedido/${id}/`, data, true);
    setAlert(true, res.message, res.status);
    return res;
  };
  